/* eslint-disable @next/next/no-css-tags*/
export const PackageFontMana = () => (
  <link
    href='//cdn.jsdelivr.net/npm/mana-font@latest/css/mana.min.css'
    id='mana-font'
    rel='stylesheet'
    type='text/css'
  />
)
